import { render, staticRenderFns } from "./editCommission.vue?vue&type=template&id=1651db0f&scoped=true"
import script from "./editCommission.vue?vue&type=script&lang=js"
export * from "./editCommission.vue?vue&type=script&lang=js"
import style0 from "./editCommission.vue?vue&type=style&index=0&id=1651db0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1651db0f",
  null
  
)

export default component.exports